import FolderFlags from "../FolderFlags";

const Flags = () => {
    return (
        <>
            <FolderFlags/>
        </>
    )
}

export default Flags;